<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" :model="filters" size="mini">
        <el-form-item>
          <el-select v-model="filters.Mode" placeholder="" @change="getList" size="small">
            <el-option value="UnComplete" label="待处理"></el-option>
            <el-option value="Complete" label="完成"></el-option>
            <el-option value="Cancel" label="取消"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.WID" placeholder="仓库列表" @change="getList" size="small" :disabled="!filters.IsAdmin">
            <el-option v-for="item in warehouses" :key="item.DataID" :value="item.DataID" :label="item.Code+item.Name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.FreightID" placeholder="货代" @change="getList" size="small">
            <el-option v-for="item in freightList" :key="item.DataID" :value="item.DataID" :label="item.ERPFreight.Code+' ['+item.ERPFreight.Name+']'"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.Types" placeholder="出库单类别" @change="getList" size="small">
            <el-option value="销售出库" label="销售出库"></el-option>
            <el-option value="盘点出库" label="盘点出库"></el-option>
            <el-option value="退货出库" label="退货出库"></el-option>
            <el-option value="调拨出库" label="调拨出库"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            ref="search"
            v-model="filters.KeyWord"
            placeholder="search..."
            size="small"
            @keyup.enter.native="getList"
          ></el-input>
        </el-form-item>
        <el-form-item label="预报时间">
          <el-col :span="11">
            <el-date-picker type="date" placeholder="开始日期" v-model="filters.StartTime" style="width: 100%;" size="small"></el-date-picker>
          </el-col>
          <el-col :span="1" style="text-align: center;">-</el-col>
          <el-col :span="11">
            <el-date-picker type="date" placeholder="结束日期" v-model="filters.EndTime" style="width: 100%;" size="small"></el-date-picker>
          </el-col>
        </el-form-item>
        <!-- <el-form-item>
         
          <el-input v-model="filters.Waybill" placeholder="开始日期"></el-input>
          <el-input v-model="filters.Waybill" placeholder="结束日期"></el-input>
        </el-form-item> -->
        <el-form-item>
          <el-autocomplete   
            :fetch-suggestions="querySearchAsync"   
            @select="handleSelectSearch"  
            placeholder="ID / SKU / Name"  
            size="small"
            style="width: 500px;"
          >  
          </el-autocomplete>  
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="getList" size="small">查询</el-button>
        </el-form-item>
        <el-form-item class="pull-right">
          <el-button v-if="this.filters.Types === '调拨出库'" type="primary" v-on:click="exportTransfer" :disabled="this.sels.length === 0" size="small">导出调拨单</el-button>
          <template v-else>
            <el-button type="primary" v-on:click="exportOrder" :disabled="this.sels.length === 0" size="small">导出匹配单</el-button>
            <el-button type="primary" v-on:click="exportPicking" :disabled="this.sels.length === 0" size="small">导出拣货单</el-button>
          </template>
          <el-button type="primary" @click="downloadExcel" :disabled="this.sels.length === 0" size="small">导出出库单Excel</el-button>
          <a class="hide-download" ref="excelDownload" :href="downloadExcelURL" :download="`${downloadExcelName}.xlsx`"></a>
        </el-form-item>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table :data="stockOutList" highlight-current-row v-loading="listLoading" @selection-change="selsChange" border>
      <el-table-column type="selection" width="">
      </el-table-column>
      <el-table-column prop="DataID" label="序号" width="">
      </el-table-column>
      <el-table-column label="单号 / 预报单" prop="OrderID" min-width="150">
        <template slot-scope="scope">
          <span v-html="renderingOrder(scope.row.OrderID)"></span> <br> <span v-html="renderingOrder(scope.row.ReferenceID)"></span>
        </template>
      </el-table-column>
      <el-table-column label="出库单属性" width="">
        <template slot-scope="scope" v-if="scope.row.Warehouse">
          <span>{{scope.row.Warehouse.Code}}</span>
          <span>{{scope.row.Warehouse.Name}}</span><br>
          <span>{{scope.row.Freight.Code}}</span>
          <img :src="returnUrl(scope.row.Freight.Logo)" style="width:20px" /><br>
          <el-tag type="info" v-show="scope.row.Types !=='普通' && scope.row.Types!==''">{{scope.row.Types | changePara}}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="包裹订单 / 包裹" width="">
        <template slot-scope="scope">
          <p>{{scope.row.Count.OrderAll}} / {{scope.row.Count.PackageAll}} </p>
        </template>
      </el-table-column>
      <el-table-column label="出库进度" width="">
        <template slot-scope="scope">
          <p>{{((scope.row.Count.OrderComplete/scope.row.Count.OrderAll)*100).toFixed(2)}}% </p>
        </template>
      </el-table-column>
      <el-table-column label="状态" prop="Status" width="">
      </el-table-column>
      <el-table-column prop="Date" label="时间" sortable width="">
        <template slot-scope="scope">
          <span>{{scope.row.UpdateDate | cutDate}}</span><br><span style="font-size:12px">{{scope.row.Date | cutDate}}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="200">
        <template slot-scope="scope">
          <el-button-group>
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row, '出库订单')">设置</el-button>
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row, '操作流水')">流水 </el-button>
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row, '日志')">日志</el-button>
            <el-button v-if="scope.row.Status===''" size="mini" type="danger" @click="handleEdit(scope.$index, scope.row, '取消')">取消</el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <!-- <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button> -->
      <el-pagination background layout="total, sizes, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="pageSize" :page-sizes="[20, 30, 50, 100]" :total="total" style="float:right;" @size-change="handleSizeChange">
      </el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog width="1200px" title="出库单详情" :visible.sync="editFormVisible" :close-on-click-modal="false" custom-class="el-dialog--large" top="10%">
      <el-form :model="editForm" label-width="100px" :rules="editFormRules" ref="editForm">
        <el-tabs type="card" v-model="activeTab">
          <el-tab-pane label="出库订单" name="出库订单">
            <el-table :data="[editForm]" highlight-current-row v-loading="listLoading" @selection-change="selsChange" border>
              <el-table-column label="序号" prop="DataID" width="80">
              </el-table-column>
              <el-table-column label="单号 / 预报单" prop="">
                <template slot-scope="scope">
                  <span v-html="renderingOrder(scope.row.OrderID)"></span> <br> <span v-html="renderingOrder(scope.row.ReferenceID)"></span>
                </template>
              </el-table-column>
              <el-table-column label="出库单属性" width="">
                <template slot-scope="scope" v-if="scope.row.Warehouse">
                  <div v-if="scope.row.Warehouse">
                    <span>{{scope.row.Warehouse.Code}}</span>
                    <span>{{scope.row.Warehouse.Name}}</span><br>
                    <span>{{scope.row.Freight.Code}}</span>
                    <img :src="returnUrl(scope.row.Freight.Logo)" style="width:20px;"/>
                    <el-tag type="info">{{scope.row.Types | changePara}}</el-tag>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="包裹订单 / 包裹" width="">
                <template slot-scope="scope" v-if="scope.row.Count">
                  <p>{{scope.row.Count.OrderAll}} / {{scope.row.Count.PackageAll}} </p>
                </template>
              </el-table-column>
              <el-table-column label="出库进度" sortable width="">
                <template slot-scope="scope" v-if="scope.row.Count">
                  <p>{{((scope.row.Count.OrderComplete/scope.row.Count.OrderAll)*100).toFixed(2)}}% </p>
                </template>
              </el-table-column>
              <el-table-column label="状态" prop="Status" width="">
              </el-table-column>
              <el-table-column label="时间">
                <template slot-scope="scope" v-if="scope.row.UpdateDate && scope.row.Date">
                  <span>{{scope.row.UpdateDate | cutDate}}</span><br><span style="font-size:12px">{{scope.row.Date | cutDate}}</span>
                </template>
              </el-table-column>
            </el-table>
            <br>
            <el-table v-if="activeTab === '出库订单'" :data="WSOOList" highlight-current-row v-loading="listLoading" @selection-change="selsChange" border max-height="350">
              <el-table-column label="顺序号" prop="SN" width="80">
              </el-table-column>
              <el-table-column label="运单号" width="200">
                <template slot-scope="scope" v-if="scope.row.ReferenceID && scope.row.Logistics">
                  <p><span v-html="renderingOrder(scope.row.ReferenceID)"></span> <br> {{scope.row.Logistics.Buyer}} <br> {{scope.row.Logistics.Remark}}</p>
                </template>
              </el-table-column>
              <el-table-column label="货代单号 / 挂号" width="180">
                <template slot-scope="scope" v-if="scope.row.Logistics">
                  <p>{{scope.row.Logistics.InsideOrder}} <br> {{scope.row.Logistics.TrackingNumber}}</p>
                </template>
              </el-table-column>
              <el-table-column label="包裹" width="220">
                <template slot-scope="scope" v-if="scope.row.Stock && scope.row.Logistics">
                  <p v-for="s in scope.row.Stock" :key="s.FreightNo">{{s.FreightNo}}<br> {{scope.row.Logistics.OrderID}} * {{s.Quantity}}</p>
                </template>
              </el-table-column>
              <el-table-column label="状态" prop="Status" width="100">
              </el-table-column>
              <el-table-column label="时间" width="120">
                <template slot-scope="scope" v-if="scope.row.Date">
                  <span>{{scope.row.Date | cutDate}}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="">
                <template slot-scope="scope">
                  <el-button-group>
                    <el-button type="primary" size="small" v-if="editForm.hasOwnProperty('Freight') && editForm.Freight.Print" @click="printOut(scope.row.DataID)">单项打印</el-button>
                    <el-button type="danger" size="small" @click="confirmStockOut(scope)">取消</el-button>
                  </el-button-group>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="操作流水" name="操作流水">
            <el-table :data="[editForm]" highlight-current-row v-loading="listLoading" @selection-change="selsChange" border>
              <el-table-column label="序号" prop="DataID">
              </el-table-column>
              <el-table-column label="单号 / 预报单" prop="">
                <template slot-scope="scope">
                  <span v-html="renderingOrder(scope.row.OrderID)"></span> <br> <span v-html="renderingOrder(scope.row.ReferenceID)"></span>
                </template>
              </el-table-column>
              <el-table-column label="出库单属性" width="">
                <template slot-scope="scope"  v-if="scope.row.Warehouse">
                  <span>{{scope.row.Warehouse.Code}}</span>
                  <span>{{scope.row.Warehouse.Name}}</span><br>
                  <span>{{scope.row.Freight.Code}}</span>
                  <img :src="returnUrl(scope.row.Freight.Logo)" style="width:20px" />
                  <el-tag type="info">{{scope.row.Types | changePara}}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="包裹订单 / 包裹" width="">
                <template slot-scope="scope" v-if="scope.row.Count">
                  <p>{{scope.row.Count.OrderAll}} / {{scope.row.Count.PackageAll}} </p>
                </template>
              </el-table-column>
              <el-table-column label="出库进度" sortable width="">
                <template slot-scope="scope" v-if="scope.row.Count">
                  <p>{{((scope.row.Count.OrderAll/scope.row.Count.PackageAll)*100).toFixed(2)}}% </p>
                </template>
              </el-table-column>
              <el-table-column label="状态" prop="Status" width="80">
              </el-table-column>
              <el-table-column label="时间">
                <template slot-scope="scope" v-if="scope.row.UpdateDate">
                  <span>{{scope.row.UpdateDate | cutDate}}</span><br><span style="font-size:12px">{{scope.row.Date | cutDate}}</span>
                </template>
              </el-table-column>
            </el-table>
            <br>
            <el-table :data="editForm && editForm.Flow" highlight-current-row v-loading="listLoading" @selection-change="selsChange" border max-height="400">
              <el-table-column label="时间" prop="" width="200" sortable>
                <template slot-scope="scope">
                  <p>{{scope.row.Date}}</p>
                </template>
              </el-table-column>
              <el-table-column label="操作人" prop="TrueName" width="" sortable></el-table-column>
              <el-table-column label="运单号" prop="OrderID"></el-table-column>
              <el-table-column label="Rcode" prop="Rcode"></el-table-column>
              <el-table-column label="价格" prop="Price"></el-table-column>
              <el-table-column label="数量" prop="Quantity" width=""></el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="日志" name="日志">
            <el-table :data="editForm && editForm.Log" highlight-current-row v-loading="listLoading" @selection-change="selsChange" border max-height="400">
              <el-table-column label="操作人" prop="Name" width="100">
              </el-table-column>
              <el-table-column label="操作记录" prop="Remark">
              </el-table-column>
              <el-table-column label="时间" prop="" width="110">
                <template slot-scope="scope">
                  <p>{{scope.row.Date | cutDate}}</p>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
        <el-form-item label="" label-width="0px">
          <el-button
            v-if="activeTab === '出库订单' && editForm.hasOwnProperty('Freight') && editForm.Freight.Print"
            type="primary"
            size="small"
            @click="printOutAll"
          >整单打印</el-button>
          <el-pagination v-if="activeTab === '出库订单'" background layout="total, sizes, prev, pager, next, jumper" @current-change="orderCurrentChange" :page-size="orderPageSize" :page-sizes="[20, 30, 50, 100]" :total="orderTotal" style="float:right;" @size-change="orderSizeChange">
          </el-pagination>
        </el-form-item>
      </el-form>
      <!-- <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
      </div> -->
    </el-dialog>
  </section>
</template>

<script>
  import util from '../../common/js/util'
  import ef from '../../common/js/exportFile'
  // import { getLodop } from '../../common/js/LodopFuncs'
  //import NProgress from 'nprogress'
  import { BaseUrl, getStockOutList, queryStockOut, updateStockOut, getWarehouseList, getFreightList, WPSkuSearch, getWSOOList, cancelStockOut, cancelStock, getWSOPicking, WSOTicketPrint} from '../../api/api'
  import qs from 'qs'
  import format from 'date-fns/format'
  export default {
    data() {
      return {
        filters: {
          FreightID: '',
          WID: '',
          IsAdmin: '',
          Types: '销售出库',
          KeyWord: '',
          StartTime: '',
          EndTime: '',
          Mode: 'UnComplete',
          SkuID: ''
        },
        activeTab: '出库订单',
        warehouses: [],
        freightList: [],
        stockOutList: [],
        WSOOList: [],
        total: 0,
        page: 1,
        pageSize: 20,
        isTransfer: false, // 调拨单
        // 指定出库单包裹列表的分页参数
        orderTotal: 0,
        orderPage: 1,
        orderPageSize: 20,
        listLoading: false,
        sels: [],//列表选中列
        editFormVisible: false,//编辑界面是否显示
        editLoading: false,
        editFormRules: {
          name: [
            { required: true, message: '请输入姓名', trigger: 'blur' }
          ]
        },
        //编辑界面数据
        // editForm: {
        //   DataID: 0,
        //   OrderID: '',
        //   WID: 0,
        //   ReferenceID: '',
        //   Warehouse: {},
        //   Flow: [],
        //   FreightID: '',
        //   Freight: {},
        //   Log: [],
        //   Count: {},
        //   Types: '',
        //   UpdateDate: '',
        //   Date: '',
        //   Status:''
        // },
        editForm: {},
        errorMessage: '',
        //收货
        receive: {
          ReceiveCount: 0,
          NewStatus: '',
          flag: false
        },
        //收货调整
        receiveAdjust: {
          ReceiveCount: 0,
          NewStatus: '',
          flag: false,
          Subject: ''
        },
        //产品提交数据模型
        // productJson: {
        //   Quantity:'',
        //   Product: []
        // },

        //变更状态
        changeStatus: '',

        addFormVisible: false, //新增界面是否显示
        addLoading: false,
        addFormRules: {
          name: [
            { required: true, message: '请输入姓名', trigger: 'blur' }
          ]
        },
        //搜索完成的显示名称
        skuName: '',
        searchName: '',

        // 用于下载出库单的URL
        downloadExcelURL: '',
        downloadExcelName: ''
      }
    },
    methods: {
      //改变页数
      handleCurrentChange (val) {
        this.page = val
        this.getList()
      },
      //改变每页显示数量
      handleSizeChange (val) {
        this.pageSize = val
        this.getList()
      },
      //指定出库单包裹列表 改变页数
      orderCurrentChange (val) {
        this.orderPage = val
        this.getOrderPackageList(this.editForm)
      },
      //指定出库单包裹列表 改变每页显示数量
      orderSizeChange (val) {
        this.orderPageSize = val
        this.getOrderPackageList(this.editForm)
      },
      //获取出库单列表
      getList () {
        let para = {
          Page: this.page,
          QueryLimitNumber: this.pageSize,
          Mode: this.filters.Mode,
          Types: this.filters.Types,
          WID: this.filters.WID,
          FreightID: this.filters.FreightID,
          SkuID: this.filters.SkuID,
          StartTime: format(this.filters.StartTime, 'YYYY-MM-DD'),
          EndTime: format(this.filters.EndTime, 'YYYY-MM-DD'),
          KeyWord: this.filters.KeyWord
          // Mode: 'InService'
        }
        this.listLoading = true
        // NProgress.start();
        getStockOutList(para).then((res) => {
          if (res.data.Ack) {
            this.total = res.data.Pagination.TotalNumberOfEntries
            this.stockOutList = res.data.DataList
            if (this.filters.WID === '' && this.filters.IsAdmin === '') {
              this.filters.WID = res.data.Head.WID
              this.filters.IsAdmin = res.data.Head.IsAdmin
            }
          } else {
            util.error(this,res.data)
            this.total = 0
            this.stockOutList = []
          }
          if (this.filters.WID === '' && this.filters.IsAdmin === '') {
            this.filters.WID = res.data.Head.WID
            this.filters.IsAdmin = res.data.Head.IsAdmin
          }
          this.listLoading = false
          // NProgress.done();
        }).catch(e => {}).finally(() => {})
      },
      //搜索
      //queryString 为在框中输入的值  
      //callback 回调函数,将处理好的数据推回  
      querySearchAsync (queryString, callback) {
        if (!queryString) {
          this.filters.SkuID = ''
          return
        }
        let para = qs.stringify({
          KeyWord: queryString
        })
        var list = [{}]
         //从后台获取到对象数组  
        WPSkuSearch(para).then((res) => {
          //在这里为这个数组中每一个对象加一个value字段, 因为autocomplete只识别value字段并在下拉列中显示
          for (let i of res.data.DataList) {
            i.value  = '[' + i.Status + ']' + '[' + i.FullSKU + ']' + i.FullName  //将CUSTOMER_NAME作为value
          }
          list = res.data.DataList
          callback(list)
        }).catch((error) => {
          console.log(error)
        })
      },
      //搜索栏选中后的处理函数
      handleSelectSearch (item) {
        this.filters.SkuID = item.DataID
        this.searchName = item.FullName
        this.getList()
      },
      //显示编辑界面
      handleEdit (index, row, tab) {
        switch (tab) {
          case '取消':
            this.$confirm('是否确定取消？').then(() => {
              cancelStock(qs.stringify({DataID: row.DataID})).then((res) => {
                if (res.data.Ack) {
                  this.$message({
                    message: '取消成功。',
                    type: 'success'
                  })
                  this.getList()
                } else {
                  util.error(this,res.data)
                }
              })
            })
            break
          default:
            this.activeTab = tab
            let para = { DataID: row.DataID }
            queryStockOut(para).then((res) => {
              this.editForm = res.data.StockOut
              this.editFormVisible = true
            })
            //查询指定出库单的订单包裹列表
            this.getOrderPackageList(row)
        }
      },
      // 整单打印
      printOutAll () {
        let dataIDList = ''
        for (let [index, item] of this.WSOOList.entries()) {
          if (index > 0) dataIDList += ','
          dataIDList += item.DataID
        }
        this.printOut(dataIDList)
      },
      // 打印出库
      printOut (DataID) {
        let parm = qs.stringify({
          FID: this.editForm.DataID,
          DataID: DataID
        })
        WSOTicketPrint(parm).then(res => {
          if (!res.data.Ack) {
            util.error(this, res.data)
            return
          }
          const _data = res.data
          // 单数过多时，TotalPDF PDF过大，后端将大于10单的合并为一个PDF，拆分为多个PDF来打印
          if (_data.Ticket && Array.isArray(_data.Ticket) && _data.Ticket.length > 0) {
            const pdfCollection = JSON.parse(JSON.stringify(_data.Ticket))
            // 延时打印拆分
            const _that = this
            function pdfSplitPrint () {
              // 要打印的文件已经执行完毕,不再往下执行
              if (pdfCollection.length === 0) return

              const { File: PDFURL } = pdfCollection.shift()
              // 如果 file 不存在，则报错
              if (!PDFURL) {
                util.error(_that, '字段 File 为空或不存在')
                return
              }

              // 打印文件
              util.LODOPrint(_that, PDFURL, 1000, 2000, _data.PrintTypes)

              // 延迟500毫秒调用自身
              setTimeout(pdfSplitPrint, 500)
            }
            // 首次启动
            pdfSplitPrint()
            return
          }
          // 单数少于等于10时，用TotalPDF打印
          const PDFURL = _data.TotalPDF === '' ? _data.DataList[0].Ticket : _data.TotalPDF
          util.LODOPrint(this, PDFURL, 1000, 2000, _data.PrintTypes)
        })
      },
      //查询指定出库单的订单包裹列表
      getOrderPackageList (row) {
        let para = {
          FID: row.DataID,
          Page: this.orderPage,
          QueryLimitNumber: this.orderPageSize
        }
        getWSOOList(para).then((res) => {
          if (res.data.Ack) {
            this.WSOOList = res.data.DataList
            this.orderTotal = res.data.Pagination.TotalNumberOfEntries
          } else {
            util.error(this,res.data)
          }
        })
      },
      confirmStockOut (scope) {
        this.$confirm(`${scope.row.ReferenceID} | ${scope.row.Logistics.Buyer} | ${scope.row.Logistics.InsideOrder}`).then(() => {
          console.log(scope)
          cancelStockOut(qs.stringify({DataID: scope.row.DataID})).then((res) => {
            if (res.data.Ack) {
              this.$message({
                message: '确认',
                type: 'success'
              })
              this.WSOOList[scope.$index].Status = '取消'
            }
          })
        })
      },
      //确认入库，更新数量
      editSubmit () {
        let $this = this
        var productJson = []
        this.editForm.ApplyProduct.forEach(function (item, index) {
          if (item.receiveNum && $this.receiveCheck(item)) {
            productJson.push({'SkuID': item.Product.DataID, 'Quantity': item.receiveNum})
          }
        })
        let para = JSON.stringify({
          DataID: this.editForm.DataID,
          OrderID: this.editForm.OrderID,
          Product: productJson
        })
        updateStockOut(para).then((res) => {
          this.editLoading = false
          if (res.data.Ack) {
            this.$message({
              message: '提交成功',
              type: 'success'
            })
            this.$refs['editForm'].resetFields()
            // this.editFormVisible = false;
            this.getList()
          } else {
            util.error(this, res.data)
          }
        })
      },
      //本次收货的数量及状态变更
      reRealTime (data, obj) {
        console.log(data)
        var total = 0
        var $this = this
        this.receive.flag = true
        this.editForm.ApplyProduct.forEach(function (item, index) {
          if(!($this.receiveCheck(item))){
            item.receiveNum = ''
          } else if (item.receiveNum) {
            item.receiveNum == '' && (item.receiveNum = '')
            total += parseInt(item.receiveNum)
          }
        })
        total <= 0 && (this.receive.flag = false)
        this.receive.ReceiveCount =  total
        this.editForm.Receive + total < this.editForm.Quantity ? this.receive.NewStatus = '待处理' : this.receive.NewStatus = '已完成'
      },
      //收货单调整的数量及状态变更
      adRealTime () {
        var total = 0
        this.editForm.ApplyProduct.forEach(function (item, index) {
          if (item.adjustNum) {
            total += parseInt(item.adjustNum)
          }
        })
        this.receiveAdjust.ReceiveCount =  total
        this.editForm.Receive + total < this.editForm.Quantity ? this.receiveAdjust.NewStatus = '待处理' : this.receiveAdjust.NewStatus = '已完成'
      },
      //收货校验
      receiveCheck (item) {
        if (item.receiveNum && parseInt(item.receiveNum) < 0) {
          this.$message.error('收货数量不能为负数，请重新核对收货数量！')
          return false
        } else if (item.receiveNum && (parseInt(item.receiveNum) + parseInt(item.Recieve) > parseInt(item.Quantity))) {
          this.$message.error('本次收货数量及已收数量之和不能大于应收数量，请重新核对收货数量！')
          return false
        } else if (item.receiveNum && parseInt(item.receiveNum) > 0 && !item.BlnSkuComplete) {
          this.$message.error('收货产品物流属性不完整（物流属性按钮显示为红色），请先补全属性后收货！')
          return false
        } else {
          console.log('true')
          return true
        }
      },
      //调整收货单
      AdjustSubmit () {
        var productJson = []
        this.editForm.ApplyProduct.forEach(function (item, index) {
          if (item.adjustNum) {
            productJson.push({'SkuID': item.Product.DataID, 'Quantity': item.adjustNum})
          }
        })
        let para = JSON.stringify({
          DataID: this.editForm.DataID,
          OrderID: this.editForm.OrderID,
          Subject: this.receiveAdjust.Subject,
          Product: productJson
        })
        adjustStockOut(para).then((res) => {
          this.editLoading = false
          if (res.data.Ack) {
            this.$message({
              message: '提交成功',
              type: 'success'
            })
            this.$refs['editForm'].resetFields()
            // this.editFormVisible = false;
            this.getList()
          } else {
            util.error(this,res.data)
          }
        })
      },
      selsChange (sels) {
        this.sels = sels
      },
      //获取仓库简化列表,用于搜索查询
      getwarehouses () {
        getWarehouseList().then((res) => {
          this.warehouses = res.data.DataList
        })
      },
      //获取货代列表，用于搜索查询
      getFreight () {
        getFreightList().then((res) => {
          this.freightList = res.data.DataList
        })
      },
      //渲染单号
      renderingOrder (value) {
        if (!value) value = ''
        return value.replace(/(\d{8}|\d{6})/ig, '<span class="el-tag el-tag--primary">$1</span>')
      },
      //返回完整图片资源URL
      returnUrl (url) {
        return util.baseUrl(url)
      },
      //导出拣货单
      exportPicking () {
        let routeData = this.$router.resolve({path: '/picking', query: {id: this.sels[0].DataID}})
        window.open(routeData.href, '_blank')
      },
      //导出匹配单
      exportOrder () {
        let routeData = this.$router.resolve({path: '/outStockOrder', query: {id: this.sels[0].DataID}})
        window.open(routeData.href, '_blank')
      },
      //导出调拨单
      exportTransfer () {
        let routeData = this.$router.resolve({path: '/Transfer', query: {id: this.sels[0].DataID}})
        window.open(routeData.href, '_blank')
      },
      // 下载出库表
      downloadExcel () {
        // 判断是都有项被选中
        if (this.sels.length === 0) {
          this.$message({
            message: '没有选中的项。',
            type: 'error'
          })
          return false
        }
        //查询指定出库单的订单包裹列表
        getWSOPicking(qs.stringify({DataID: this.sels[0].DataID})).then((res) => {
          if (res.data.Ack) {
            let _d, pickData, options, EF
            _d = res.data
            // 设置Excel文件名
            this.downloadExcelName = `${_d.StockOut.Warehouse.Name}-${_d.StockOut.Freight.Code || '[货代]'}-${_d.StockOut.Types}-${_d.StockOut.OrderID}-拣货单`
            // 处理接口数据
            pickData = _d.Picking.map((value, index) => {
              return {
                '单号': value.FreightNo,
                '包含产品': (p => {
                              let tmpText = ''
                              for (let v of p) {
                                tmpText += `[${v.FullSKU}]${v.FullName} * ${v.Quantity}\n`
                              }
                              // 删除最后的换行符
                              tmpText = tmpText.slice(0, -1)
                              return tmpText
                            })(value.Product),
                '包裹数量': value.Quantity,
                '拣出数量': '',
                '操作人': ''
              }
            })
            // 传递参数配置
            options = {
              sheetName: `订${_d.StockOut.Count.OrderAll}|包${_d.StockOut.Count.PackageAll}`,
              pickData: pickData
            }
            EF = new ef(options)
            this.downloadExcelURL = EF.exportExcel()
            setTimeout(() => {
              this.$refs.excelDownload.click()
            }, 200)
          } else {
            util.error(this,res.data)
          }
        })
      },
      /**
       * @description: 进入页面时,聚焦到 search
       * @return {*}
       */
      searchFocus () {
        this.$refs.search.focus()
      }
    },
    filters: {
      cutDate (date) {
        if (!date) date = ''
        return date.split(' ')[0]
      },
      changePara (value) {
        value === '普通' ? value = '' : value = value    
        return value
      }
    },
    mounted () {
      this.searchFocus()
      this.getList()
      this.getwarehouses()
      this.getFreight()
    }
  }

</script>

<style scoped>
  .el-form-item{
    margin-bottom: 10px !important;
  }
  .el-dialog--small{
    width: 60% !important;
  }
  .w60 {
    width: 60%;
  }
  .hide-download {
    display: hidden;
  }
</style>



// WEBPACK FOOTER //
// stockOutList.vue?629389de